import React from 'react';



type Props = {
  className?: string;
}
export const CVBlurVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '16' height = '16' viewBox = '0 0 16 16' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'currentColor' stroke = 'currentColor' strokeWidth = '0.4' d = 'M10.8421 1H3.26316C2.56842 1 2 1.57273 2 2.27273V11.1818H3.26316V2.27273H10.8421V1ZM12.7368 3.54545H5.78947C5.09474 3.54545 4.52632 4.11818 4.52632 4.81818V13.7273C4.52632 14.4273 5.09474 15 5.78947 15H12.7368C13.4316 15 14 14.4273 14 13.7273V4.81818C14 4.11818 13.4316 3.54545 12.7368 3.54545ZM12.7368 13.7273H5.78947V4.81818H12.7368V13.7273Z'/>
      <g clip-path = 'url(#clip0_2889_49088)'>
        <path fill = 'currentColor' stroke = 'currentColor' strokeWidth = '0.2' d = 'M10.9011 1H5.09889L1 5.09889V10.9011L5.09889 15H10.9011L15 10.9011V5.09889L10.9011 1ZM13.4444 10.2556L10.2556 13.4444H5.74444L2.55556 10.2556V5.74444L5.74444 2.55556H10.2556L13.4444 5.74444V10.2556Z' />
        <path fill = 'currentColor' stroke = 'currentColor' strokeWidth = '0.2' d = 'M8.00065 11.3333C8.36884 11.3333 8.66732 11.0349 8.66732 10.6667C8.66732 10.2985 8.36884 10 8.00065 10C7.63246 10 7.33398 10.2985 7.33398 10.6667C7.33398 11.0349 7.63246 11.3333 8.00065 11.3333Z' />
        <path fill = 'currentColor' stroke = 'currentColor' strokeWidth = '0.2' d = 'M7.33398 4.6665H8.66732V9.33317H7.33398V4.6665Z' />
      </g>
      <defs>
        <clipPath id = 'clip0_2889_49088'>
          <rect width = '16' height = '16' fill = 'currentColor'/>
        </clipPath>
      </defs>
    </svg>
  );
};
